<template>
  <div class="p-3">
    <c-tabs variant="pills" vertical>
      <c-tab active title="Billing account">
        <account :organisation="organisation" />
      </c-tab>
      <c-tab title="Invoices">
        <invoices :organisation="organisation" />
      </c-tab>
    </c-tabs>
  </div>
</template>

<script>
import Account from './account';
import Invoices from './invoices';

export default {
  components: {
    Invoices,
    Account,
  },

  props: {
    organisation: Object,
  },

  data() {
    return {};
  },
  methods: {},
};
</script>
